import { render, staticRenderFns } from "./image-use-demo.vue?vue&type=template&id=5aa89ad5"
import script from "./image-use-demo.vue?vue&type=script&lang=js"
export * from "./image-use-demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports